// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main{font-family:\"Noto Sans KR\",sans-serif;font-weight:700;margin:0 auto}#main .left{float:left;width:750px}#main .right{float:right;width:350px}#main:after{content:\"\";display:table;table-layout:fixed;clear:both}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
